import { ModelToRun } from '@/scenes/engine/common/constants'

/** A template style as selected from the AI templates grid. */
export interface MagicTemplateStyleParams {
  prompt: string
  /** Backend model version string, e.g. `gpt-image-1`, `gemini-2.5-flash-image`. */
  model?: string
  aspectRatio?: number
  quality?: number
}

/**
 * Maps a template's backend model version string onto the provider to run.
 *
 * Unknown/absent versions resolve to OpenAI, which is what the editor's
 * `'default'` fallback already did — `generateImageBaseOnImage` routes every
 * unrecognised provider to `runOpenAiEdit`.
 */
export function resolveMagicTemplateModel(model?: string): ModelToRun {
  if (!model) return ModelToRun.OPENAI
  if (model.startsWith('gpt')) return ModelToRun.OPENAI
  if (model.startsWith('gemini')) return ModelToRun.GEMINI
  if (model.startsWith('flux')) return ModelToRun.FLUX
  if (model.startsWith('qwen')) return ModelToRun.QWEN
  return ModelToRun.OPENAI
}

/** Max edge the editor resizes a restyled result to before it lands on canvas. */
export const MAGIC_TEMPLATE_RESULT_MAX_EDGE = 1280

/** Analytics `type` the editor reports for template generations. */
export const MAGIC_TEMPLATE_ANALYTICS_TYPE = 'Restyle'
